import { createActions } from 'redux-actions';

export const actions = createActions({
  DISMISSIBLE: {
    DISMISS: (value) => value,
    SET_DISMISSED: (value) => value,
  },
}).dismissible;
